import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as Actions from './actions';

const State = Record({
    showModal: false,
    modalStatePeriod: null,
    loadingDate: null,
});

export default handleActions(
    {
        [Actions.confirming.type]: (state, {payload}) => {
            return state.merge({
                loadingDate: payload.loadingDate,
            });
        },
        [Actions.confirmingSuccess.type]: state => {
            return state.merge({
                loadingDate: null,
            });
        },
        [Actions.confirmingFailed.type]: state => {
            return state.merge({
                loadingDate: null,
            });
        },
        [Actions.showModal.type]: (state, {payload}) => {
            return state.merge({
                showModal: payload.show,
                modalStatePeriod: payload.statePeriod,
            });
        },
    },
    new State(),
);
